export default __webpack_public_path__ + "static/media/vietnam.73846779.svg";